import React, { useState } from "react";

const InputWithSuggestions = ({
    label,
    value,
    cssClass,
    onChange,
    options = [],
    optionKey = "key",      // e.g. code
    optionValue = "value",  // e.g. name
    onSelect,
    onCreate
}) => {
    const [showList, setShowList] = useState(false);

    const search = (value || "").toLowerCase();

    // Search by both key and value
    const filtered = options.filter((item) => {
        const key = String(item[optionKey] || "").toLowerCase();
        const val = String(item[optionValue] || "").toLowerCase();

        return key.includes(search) || val.includes(search);
    });

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <input
                type="text"
                value={value || ""}
                placeholder={label}
                className={`${cssClass} w-full`}
                onChange={(e) => {
                    onChange(e.target.value);
                    setShowList(true);
                }}
                onFocus={() => setShowList(true)}
                onBlur={() => setTimeout(() => setShowList(false), 200)}
                style={{
                    width: "100%",
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                }}
            />

            {showList && (value || "") && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ddd",
                        zIndex: 999,
                        maxHeight: "180px",
                        overflowY: "auto",
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    padding: "8px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                }}
                                onMouseDown={() => {
                                    onSelect?.(item);

                                    // Show only the key in input
                                    onChange(item[optionKey]);

                                    // If you want both, use this instead:
                                    // onChange(`${item[optionKey]} - ${item[optionValue]}`);

                                    setShowList(false);
                                }}
                            >
                                <div>
                                    <strong>{item[optionKey]}</strong>
                                    {optionValue && (
                                        <span> - {item[optionValue]}</span>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div
                            style={{
                                padding: "8px",
                                color: "#777",
                            }}
                        >
                            No matching records
                        </div>

                        // Uncomment if you want Add New functionality

                        // <div
                        //     style={{
                        //         padding: "8px",
                        //         cursor: "pointer",
                        //         color: "blue"
                        //     }}
                        //     onMouseDown={() => {
                        //         onCreate?.(value);
                        //         setShowList(false);
                        //     }}
                        // >
                        //     ➕ Add "{value}"
                        // </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InputWithSuggestions;